class BlogCarousel extends HTMLElement {
    constructor() {
        super();
        this.swiperContainer = this.querySelector('swiper-container');
        this.sectionAttributes = this.dataset.sectionAttributes ? JSON.parse(this.dataset.sectionAttributes.replaceAll('`', '"')) : {};
        this.tags = this.sectionAttributes.tags || '';
        this.postLimit = this.sectionAttributes.post_limit || 10;
        this.showDate = this.sectionAttributes.show_date || false;
        this.showImage = this.sectionAttributes.show_image || false;
        this.fetchBlogPosts();
    }
    fetchBlogPosts() {
        fetch('/search/suggest.json?resources[type]=article&resources[options][fields]=tag&q=' + this.tags)
            .then(response => response.json())
            .then(data => {
                this.posts = data.resources?.results?.articles.slice(0, this.postLimit) || [];
                window.waitForEl('.swiper-initialized', this)
                    .then(this.mountPosts.bind(this));
            })
            .catch(error => {
                console.error('Error fetching blog posts:', error);
            })
    }
    mountPosts() {
        if (this.posts.length === 0) {
            console.warn('No blog posts found for the specified tags.');
            return;
        }
        this.classList.remove('hidden');
        const swiper = this.swiperContainer.swiper;
        if (!swiper) {
            console.error('Swiper instance not found');
            return;
        }
        const slideTemplate = this.querySelector('#blog-post-slide-template');
        this.posts.forEach(post => {
            const slide = slideTemplate.cloneNode(true);
            slide.removeAttribute('id');
            if (this.showImage && post.featured_image && post.featured_image.url) {
                slide.querySelector('.article-card__image a').href = post.url;
                const imageEl = slide.querySelector('.article-card__image img');
                imageEl.removeAttribute('srcset');
                imageEl.src = post.featured_image.url;
                imageEl.alt = post.featured_image.alt || post.title;
                imageEl.loading = 'lazy';
                imageEl.classList.add('lazyload');
            } else {
                const imageEl = slide.querySelector('.article-card__image-wrapper img');
                imageEl && imageEl.remove();
            }
            if (this.showDate) {
                const date = new Date(post.published_at);
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
                const datePublishedEl = slide.querySelector('.article-card__info time');
                datePublishedEl.textContent = formattedDate;
                datePublishedEl.setAttribute('datetime', post.published_at);
            }
            slide.querySelector('.card__heading a').textContent = post.title;
            slide.querySelector('.card__heading a').href = post.url;
            const readMore = slide.querySelector('.article-card__excerpt a').cloneNode(true);
            readMore.href = post.url;
            const summaryText = post.summary_html.replace(/<[^>]+>/g, '').replace("[...]", "");
            const summarizedWords = summaryText.split(/\s+/).slice(0, 37).join(' ');
            slide.querySelector('.article-card__excerpt').textContent = summarizedWords + '...';
            slide.querySelector('.article-card__excerpt').appendChild(readMore);
            swiper.appendSlide(slide);
        });
        swiper.removeSlide(0);
        swiper.update();
    }
}
const mountBlogCarousel = () => {
    customElements.define('blog-carousel', BlogCarousel);
};
if ('requestIdleCallback' in window) requestIdleCallback(mountBlogCarousel);
else setTimeout(mountBlogCarousel, 200);